// When we deploy a new release, we need to make sure that a full page reload
// happens when a request is made with Unpoly, otherwise we may still be using
// stale assets from the previous release.
up.on('up:request:loaded', event => {
  const previousAssetVersion = window.steadyConfig.releaseVersion
  const fragmentAssetVersion = event.response.header('x-release')

  if (previousAssetVersion && fragmentAssetVersion && previousAssetVersion !== fragmentAssetVersion) {
    if (event.request.method === 'GET') event.request.navigate()
  }
})
